<div class="com" [class.com--chat-aberto]="idAberto">
  <!-- COLUNA ESQUERDA: interessados -->
  <aside class="com-lista" aria-label="Interessados">
    <header class="com-lista__cabecalho">
      <a class="com-lista__voltar" routerLink="/admin/mia-gestor"><i class="fas fa-chevron-left"></i> Mia Gestor</a>
      <div class="com-lista__titulo">
        <h4>Atendimento comercial</h4>
        <button type="button" class="com-atualizar" (click)="atualize()" [disabled]="carregando"
                [title]="atualizadoEm ? 'Atualizado às ' + (atualizadoEm | date:'HH:mm:ss') + ' · atualiza sozinho a cada 15 s' : 'Atualizar'"
                aria-label="Atualizar atendimentos">
          <i class="fas fa-sync-alt" [class.fa-spin]="carregando"></i>
        </button>
      </div>

      <div class="com-modelo">
        <span class="com-modelo__rotulo" id="com-modelo-rotulo">Modelo da Mia no SDR · vale da próxima mensagem em diante</span>
        <div class="com-modelo__opcoes" role="radiogroup" aria-labelledby="com-modelo-rotulo">
          <button type="button" *ngFor="let modelo of modelos" role="radio" class="com-modelo__opcao"
                  [class.com-modelo__opcao--ativa]="modeloEscolhido === modelo.id"
                  [attr.aria-checked]="modeloEscolhido === modelo.id"
                  [disabled]="salvandoModelo" (click)="escolhaModelo(modelo.id)">
            <strong>{{ modelo.rotulo }}</strong>
            <small>{{ modelo.dica }}</small>
          </button>
        </div>
        <small class="com-modelo__erro" *ngIf="erroModelo" role="alert">{{ erroModelo }}</small>
      </div>

      <div class="com-busca">
        <i class="fas fa-search"></i>
        <input type="text" [(ngModel)]="filtro" placeholder="Buscar por nome, telefone ou motivo…" aria-label="Buscar interessado">
      </div>

      <div class="com-filtros" role="tablist" aria-label="Filtrar interessados">
        <button type="button" role="tab" [attr.aria-selected]="filtroFase === 'todas'"
                [class.com-filtros__item--ativo]="filtroFase === 'todas'" (click)="altereFiltro('todas')">
          Todos
        </button>
        <button type="button" role="tab" class="com-filtros__fila" [attr.aria-selected]="filtroFase === 'equipe'"
                [class.com-filtros__item--ativo]="filtroFase === 'equipe'" (click)="altereFiltro('equipe')">
          <span class="com-filtros__sinal"></span> Pedem a equipe
          <span class="com-filtros__contagem" *ngIf="quantidade('equipe') > 0">{{ quantidade('equipe') }}</span>
        </button>
        <button type="button" role="tab" [attr.aria-selected]="filtroFase === 'conversa'"
                [class.com-filtros__item--ativo]="filtroFase === 'conversa'" (click)="altereFiltro('conversa')">
          Em conversa
        </button>
        <button type="button" role="tab" [attr.aria-selected]="filtroFase === 'teste'"
                [class.com-filtros__item--ativo]="filtroFase === 'teste'" (click)="altereFiltro('teste')">
          Teste
        </button>
      </div>
    </header>

    <div class="com-alerta com-alerta--lista" *ngIf="erro && !idAberto" role="alert">
      <i class="fas fa-exclamation-circle"></i><span>{{ erro }}</span>
    </div>

    <div class="com-lista__corpo">
      <ng-container *ngIf="carregando && !atendimentos.length">
        <div class="com-skeleton" *ngFor="let i of [1,2,3,4,5]">
          <div class="com-skeleton__avatar"></div>
          <div class="com-skeleton__linhas">
            <div class="com-skeleton__linha" style="width: 60%"></div>
            <div class="com-skeleton__linha" style="width: 85%"></div>
          </div>
        </div>
      </ng-container>

      <div class="com-vazio" *ngIf="!carregando && !filtrados.length">
        <div class="com-vazio__icone"><i class="fas" [class.fa-handshake]="!atendimentos.length" [class.fa-search]="atendimentos.length"></i></div>
        <h5 *ngIf="!atendimentos.length">Nenhum interessado ainda</h5>
        <h5 *ngIf="atendimentos.length">Nada por aqui</h5>
        <p *ngIf="!atendimentos.length">Os atendimentos recebidos pelo número comercial aparecem aqui.</p>
        <p *ngIf="atendimentos.length && filtro">Nada encontrado para “{{ filtro }}”.</p>
        <p *ngIf="atendimentos.length && !filtro && filtroFase === 'equipe'">Nenhum interessado aguardando a equipe agora.</p>
        <p *ngIf="atendimentos.length && !filtro && filtroFase !== 'equipe'">Nenhum atendimento nesta etapa.</p>
      </div>

      <button type="button" class="com-item" *ngFor="let item of filtrados; trackBy: rastreieAtendimento"
              [class.com-item--ativo]="idAberto === item.atendimentoId"
              [class.com-item--equipe]="pedeEquipe(item)"
              (click)="abra(item.atendimentoId)">
        <div class="com-avatar" [style.background]="corAvatar(item)">{{ iniciais(item) }}</div>
        <div class="com-item__info">
          <div class="com-item__topo">
            <span class="com-item__nome">{{ nome(item) }}</span>
            <span class="com-item__hora">{{ horaRelativa(item.ultimaInteracao) }}</span>
          </div>
          <span class="com-item__previa">{{ item.ultimaMensagem }}</span>
          <div class="com-item__chips">
            <span class="com-chip com-chip--fase" [attr.data-fase]="item.fase">{{ rotuloFase(item.fase) }}</span>
            <span class="com-chip com-chip--equipe" *ngIf="pedeEquipe(item)" [title]="item.encaminhamento.motivo">
              <span class="com-chip__ponto"></span> equipe
            </span>
            <span class="com-chip com-chip--parou" *ngIf="pediuParaParar(item)" title="O contato pediu para não receber mensagens">
              <i class="fas fa-hand-paper"></i> pediu para parar
            </span>
            <span class="com-chip com-chip--entrega" *ngIf="entregaIncerta(item)" title="A última resposta pode não ter chegado ao interessado. Confira no WhatsApp.">
              <i class="fas fa-exclamation-triangle"></i> entrega
            </span>
          </div>
        </div>
      </button>
    </div>
  </aside>

  <!-- COLUNA CENTRAL: conversa -->
  <section class="com-chat" aria-live="polite">
    <div class="com-chat__vazio" *ngIf="!idAberto">
      <div class="com-chat__vazio-arte"><i class="fas fa-comments"></i></div>
      <h4>Acompanhe o atendimento comercial</h4>
      <p>Escolha um interessado ao lado para ver a conversa com a Mia,<br>o que ela já descobriu e em que etapa ele está.</p>
    </div>

    <div class="com-chat__carregando-tela" *ngIf="idAberto && abrindo">
      <i class="fas fa-circle-notch fa-spin"></i> Abrindo conversa…
    </div>

    <div class="com-alerta" *ngIf="idAberto && !selecionado && !abrindo && erro" role="alert">
      <i class="fas fa-exclamation-circle"></i><span>{{ erro }}</span>
      <button type="button" (click)="abra(idAberto)">Tentar de novo</button>
    </div>

    <ng-container *ngIf="selecionado">
      <header class="com-chat__cabecalho">
        <button type="button" class="com-chat__voltar" (click)="fecheConversa()" aria-label="Voltar para os interessados">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div class="com-avatar com-avatar--grande" [style.background]="corAvatar(selecionado)">{{ iniciais(selecionado) }}</div>
        <div class="com-chat__contato">
          <strong>{{ nome(selecionado) }}</strong>
          <small>{{ telefone(selecionado) }} · {{ rotuloFase(selecionado.fase) }}</small>
        </div>
        <div class="com-chat__acoes">
          <span class="com-chip com-chip--mia" *ngIf="estado === 'mia'"><i class="fas fa-robot"></i> Mia atendendo</span>
          <span class="com-chip com-chip--pausada" *ngIf="estado === 'equipe'"><i class="fas fa-headset"></i> Com a equipe</span>
          <button type="button" class="com-acao com-acao--assumir" *ngIf="estado === 'mia'"
                  [disabled]="salvando" (click)="controle('humano')">
            <i class="fas" [class.fa-headset]="!salvando" [class.fa-circle-notch]="salvando" [class.fa-spin]="salvando"></i>
            {{ salvando ? 'Assumindo…' : 'Assumir conversa' }}
          </button>
          <button type="button" class="com-acao com-acao--devolver" *ngIf="estado === 'equipe'"
                  [disabled]="salvando" (click)="controle('devolver')">
            <i class="fas" [class.fa-robot]="!salvando" [class.fa-circle-notch]="salvando" [class.fa-spin]="salvando"></i>
            {{ salvando ? 'Devolvendo…' : 'Devolver à Mia' }}
          </button>
          <button type="button" class="com-acao-icone com-acao-icone--bloqueio" *ngIf="estado === 'mia' || estado === 'equipe'"
                  [disabled]="salvando" (click)="controle('bloquear')"
                  title="Desativar a Mia para este contato" aria-label="Desativar a Mia para este contato">
            <i class="fas fa-ban"></i>
          </button>
          <a class="com-botao-whatsapp" [href]="linkWhatsapp(selecionado)" target="_blank" rel="noopener"
             title="Abrir conversa no WhatsApp" aria-label="Abrir conversa no WhatsApp">
            <i class="fab fa-whatsapp"></i>
          </a>
          <button type="button" class="com-acao-icone" [class.com-acao-icone--ativo]="fichaAberta"
                  (click)="fichaAberta = !fichaAberta" [attr.aria-pressed]="fichaAberta"
                  title="Ficha do interessado" aria-label="Mostrar ou esconder a ficha do interessado">
            <i class="fas fa-id-card"></i>
            <span class="com-acao-icone__contagem" *ngIf="fatos.length">{{ fatos.length }}</span>
          </button>
        </div>
      </header>

      <div class="com-faixa com-faixa--bloqueio" *ngIf="estado === 'bloqueada'">
        <i class="fas fa-ban"></i>
        <span><strong>A Mia está desativada para este contato.</strong> Ela não responde mais este número — continue pelo WhatsApp empresarial.</span>
      </div>
      <div class="com-faixa com-faixa--neutra" *ngIf="estado === 'desabilitada'">
        <i class="fas fa-power-off"></i>
        <span><strong>Atendimento automático desabilitado.</strong> A Mia não responde interessados neste canal enquanto estiver desligado.</span>
      </div>
      <div class="com-faixa com-faixa--equipe" *ngIf="pedeEquipe(selecionado)">
        <i class="fas fa-user-friends"></i>
        <span><strong>Pedido para a equipe</strong> {{ selecionado.encaminhamento.motivo }}</span>
      </div>
      <div class="com-faixa com-faixa--parou" *ngIf="pediuParaParar(selecionado)">
        <i class="fas fa-hand-paper"></i>
        <span><strong>O contato pediu para não receber mensagens.</strong> {{ selecionado.encaminhamento.motivo }}</span>
      </div>
      <div class="com-alerta" *ngIf="erro" role="alert">
        <i class="fas fa-exclamation-circle"></i><span>{{ erro }}</span>
        <button type="button" class="com-alerta__fechar" (click)="erro = ''" aria-label="Fechar aviso"><i class="fas fa-times"></i></button>
      </div>

      <div class="com-chat__corpo" #corpoChat>
        <div class="com-sistema" *ngIf="!itensChat.length"><i class="fas fa-info-circle"></i> Nenhuma mensagem registrada ainda.</div>
        <ng-container *ngFor="let item of itensChat; trackBy: rastreieItem">
          <div class="com-separador" *ngIf="item.tipo === 'separador'"><span>{{ item.label }}</span></div>

          <div class="com-sistema" *ngIf="item.tipo === 'mensagem' && item.mensagem.papel === 'sistema'">
            <i class="fas fa-info-circle"></i> {{ item.mensagem.texto }}
          </div>

          <div class="com-bolha-linha" *ngIf="item.tipo === 'mensagem' && item.mensagem.papel !== 'sistema'"
               [attr.data-turno]="item.mensagem.id"
               [class.com-bolha-linha--direita]="item.mensagem.papel !== 'usuario'"
               [class.com-bolha-linha--destacada]="mensagemDestacada === item.mensagem.id">
            <div class="com-bolha" [class.com-bolha--interessado]="item.mensagem.papel === 'usuario'"
                 [class.com-bolha--mia]="item.mensagem.papel === 'gestor'"
                 [class.com-bolha--equipe]="item.mensagem.papel !== 'usuario' && item.mensagem.papel !== 'gestor'">
              <div class="com-bolha__texto" [innerHTML]="item.mensagem.texto | formataWhatsapp"></div>
              <div class="com-bolha__meta">
                <span class="com-bolha__autor" *ngIf="item.mensagem.papel === 'gestor'"><i class="fas fa-robot"></i> Mia</span>
                {{ item.mensagem.criadoEm | date:'HH:mm' }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <footer class="com-conducao" *ngIf="estado === 'mia'">
        <div class="com-conducao__icone"><i class="fas fa-robot"></i></div>
        <div class="com-conducao__texto">
          <strong>A Mia está conduzindo esta conversa</strong>
          <span>Você acompanha por aqui e pode entrar quando quiser.</span>
        </div>
        <button type="button" (click)="controle('humano')" [disabled]="salvando" [attr.aria-busy]="salvando">
          <i class="fas" [class.fa-headset]="!salvando" [class.fa-circle-notch]="salvando" [class.fa-spin]="salvando"></i>
          {{ salvando ? 'Assumindo…' : 'Assumir agora' }}
        </button>
      </footer>
      <footer class="com-conducao com-conducao--equipe" *ngIf="estado === 'equipe'">
        <div class="com-conducao__icone"><i class="fas fa-headset"></i></div>
        <div class="com-conducao__texto">
          <strong>A equipe está com esta conversa</strong>
          <span>Continue pelo WhatsApp empresarial conectado. A Mia fica pausada conforme a configuração de atendimento da empresa.</span>
        </div>
        <a class="com-conducao__whats" [href]="linkWhatsapp(selecionado)" target="_blank" rel="noopener">
          <i class="fab fa-whatsapp"></i> Abrir WhatsApp
        </a>
      </footer>
    </ng-container>
  </section>

  <!-- COLUNA DIREITA: ficha do interessado -->
  <aside class="com-ficha" *ngIf="selecionado && fichaAberta" aria-label="Ficha do interessado">
    <header class="com-ficha__cabecalho">
      <h5>Ficha do interessado</h5>
      <button type="button" class="com-ficha__fechar" (click)="fichaAberta = false" aria-label="Fechar ficha"><i class="fas fa-times"></i></button>
    </header>
    <div class="com-ficha__corpo">
      <section class="com-bloco">
        <h6>Etapa</h6>
        <ol class="com-trilho" [attr.aria-label]="'Etapa ' + (indiceFase(selecionado.fase) + 1) + ' de ' + fases.length + ': ' + rotuloFase(selecionado.fase)">
          <li *ngFor="let etapa of fases; let i = index" [title]="etapa.rotulo"
              [class.com-trilho__passo--feito]="i <= indiceFase(selecionado.fase)"
              [class.com-trilho__passo--atual]="i === indiceFase(selecionado.fase)"></li>
        </ol>
        <p class="com-trilho__rotulo">
          <strong>{{ rotuloFase(selecionado.fase) }}</strong>
          <span *ngIf="indiceFase(selecionado.fase) >= 0">etapa {{ indiceFase(selecionado.fase) + 1 }} de {{ fases.length }}</span>
        </p>
        <div class="com-adiar" *ngIf="selecionado.fase === 'CRIAR_TESTE'">
          <label for="motivo-adiamento">Adiar a criação do teste</label>
          <input id="motivo-adiamento" [(ngModel)]="motivoAdiamento" maxlength="300" [disabled]="salvando"
                 placeholder="Motivo do adiamento">
          <button type="button" (click)="controle('voltar_sdr')" [disabled]="salvando || !motivoAdiamento.trim()">
            <i class="fas fa-undo-alt"></i> Voltar para a conversa comercial
          </button>
          <small>Invalida a proposta pendente. O controle de atendimento humano permanece como está.</small>
        </div>
      </section>

      <section class="com-bloco" *ngIf="selecionado.teste">
        <h6>Links do teste</h6>
        <app-links-teste-gestor [teste]="selecionado.teste"></app-links-teste-gestor>
      </section>

      <section class="com-bloco">
        <h6>O que já sabemos <span class="com-bloco__contagem" *ngIf="fatos.length">{{ fatos.length }}</span></h6>
        <p class="com-bloco__vazio" *ngIf="!fatos.length">A Mia ainda não registrou informações de qualificação.</p>
        <p class="com-bloco__dica" *ngIf="fatos.length">Toque num item para ver de onde a Mia tirou.</p>
        <ul class="com-fatos" *ngIf="fatos.length">
          <li *ngFor="let fato of fatos; trackBy: rastreieFato" [class.com-fatos__item--aberto]="fatoAberto === fato.campo">
            <button type="button" class="com-fatos__linha" (click)="abraFato(fato)" [attr.aria-expanded]="fatoAberto === fato.campo">
              <span class="com-fatos__rotulo">{{ fato.rotulo }}</span>
              <span class="com-fatos__valor">{{ fato.valor }}</span>
            </button>
            <div class="com-fatos__origem" *ngIf="fatoAberto === fato.campo">
              <blockquote *ngIf="temTrecho(fato)">“{{ fato.evidencia }}”</blockquote>
              <small>
                <ng-container *ngIf="fato.turnoId">Mensagem #{{ fato.turnoId }}</ng-container><ng-container *ngIf="fato.turnoId && fato.registradoEm"> · </ng-container>{{ fato.registradoEm | date:'dd/MM HH:mm' }}
                <ng-container *ngIf="fato.turnoId && mensagemNoChat(fato)"> · destacada na conversa</ng-container>
              </small>
            </div>
          </li>
        </ul>
      </section>

      <section class="com-bloco">
        <h6>
          <button type="button" class="com-bloco__alternar" (click)="historicoAberto = !historicoAberto" [attr.aria-expanded]="historicoAberto"
                  [disabled]="!selecionado.fases?.length">
            Histórico da jornada
            <span class="com-bloco__contagem" *ngIf="selecionado.fases?.length">{{ selecionado.fases.length }}</span>
            <i class="fas fa-chevron-down" [class.com-bloco__seta--aberta]="historicoAberto" *ngIf="selecionado.fases?.length" aria-hidden="true"></i>
          </button>
        </h6>
        <p class="com-bloco__vazio" *ngIf="!selecionado.fases?.length">Nenhuma mudança de etapa registrada.</p>
        <ol class="com-linha-tempo" *ngIf="historicoAberto && selecionado.fases?.length">
          <li *ngFor="let fase of selecionado.fases">
            <strong>{{ rotuloFase(fase.de) }} <i class="fas fa-long-arrow-alt-right"></i> {{ rotuloFase(fase.para) }}</strong>
            <small>{{ fase.criadaEm | date:'dd/MM HH:mm' }} · por {{ rotuloOrigem(fase.origem) }}</small>
            <p *ngIf="fase.motivo">{{ fase.motivo }}</p>
          </li>
        </ol>
      </section>
    </div>
  </aside>
</div>
